//export const baseUrl = "https://localhost:7100";
export const baseUrlAdmin = "https://bees.express:6006";
export const baseUrlUser = "https://bees.express:6001";

export const apiBaseUrlAdmin = baseUrlAdmin + "/api";
export const apiBaseUrlUser = baseUrlUser + "/api";